import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=1c81d37e&scoped=true&"
import script from "./ChannelItem.vue?vue&type=script&lang=ts&"
export * from "./ChannelItem.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelItem.vue?vue&type=style&index=0&id=1c81d37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81d37e",
  null
  
)

export default component.exports